import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { OTPTYPE } from 'BreetHelpers';

interface IAuthCredentials {
	email: string;
	password: string;
	businessId?: string;
	otpType?: OTPTYPE;
}

interface IAuthCredentialsState {
	credentials: IAuthCredentials | null;
}

const initialState: IAuthCredentialsState = {
	credentials: null,
};

export const authCredentialsSlice = createSlice({
	name: 'authCredentials',
	initialState,
	reducers: {
		setCredentials: (state, action: PayloadAction<IAuthCredentials>) => {
			state.credentials = action.payload;
		},
		clearCredentials: (state) => {
			state.credentials = null;
		},
	},
	selectors: {
		selectCredentials: (state) => state.credentials,
	},
});

export const { setCredentials, clearCredentials } = authCredentialsSlice.actions;

export const { selectCredentials } = authCredentialsSlice.selectors;

export default authCredentialsSlice.reducer;
